import React from 'react';
import { motion } from 'framer-motion';

const ContactSection = ({ company }) => {
  if (!company.teamMembers?.[0]?.email) {
    return null;
  }

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.35 }} className="bg-white/95 backdrop-blur-lg rounded-3xl p-6 sm:p-10 shadow-2xl text-center mb-8">
      <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">Interested in Investing?</h2>
      <p className="text-gray-600 mb-6">Get in touch with us to learn more about this opportunity.</p>
      <a
        href={`mailto:${company.teamMembers[0].email}`}
        className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl hover:shadow-lg transition-all"
      >
        Contact Us
      </a>
    </motion.div>
  );
};

export default ContactSection; 